import React from "react";
import { Tunnel } from "react-tunnels";
import { css } from "styled-components";
import { Query } from "react-apollo";

import { BackButtonTopbar } from "@arachnys/styleguide/PageHeader";
import ApolloPaginationTable from "@arachnys/flow-app/src/container/ApolloPaginationTable";
import { formatDatetimeString } from "@arachnys/flow-app/src/formatters";
import { withApolloState } from "../../util/apollo";
import { DEFAULT_PAGESIZE } from "../../config";
import { DocumentLink } from "../../container/Documents";
import { GET_BULKUPLOAD_HISTORY } from "./queries";

const styles = {
    title: css`
        font-size: 24px;
        font-weight: bold;
    `,
};

const columns = [
    {
        Header: "File Name",
        id: "filename",
        accessor: "node.filename",
    },
    {
        Header: "Uploaded By",
        id: "uploadby",
        maxWidth: 150,
        accessor: "node.authorName",
    },
    {
        Header: "Upload Date",
        id: "uploaddate",
        maxWidth: 150,
        accessor: "node.createdDate",
        Cell: row =>
            formatDatetimeString({ str: row.original.node.createdDate }),
    },
    {
        Header: "Status",
        id: "status",
        maxWidth: 100,
        accessor: "node.status",
    },
    {
        Header: "Errors",
        id: "errors",
        maxWidth: 100,
        accessor: "node.errorsCount",
    },
    {
        id: "errorfile",
        maxWidth: 150,
        Cell: row => {
            const node = row.original.node;
            if (node.errorsCount) {
                return (
                    <DocumentLink
                        documentDatum={{
                            documentId: node.errorFileId,
                            documentTitle: "Download error file",
                            documentName:
                                "errorsfile-" +
                                node.filename.replace(/.xlsx$/, ".csv"),
                        }}
                    />
                );
            }
            return "-";
        },
    },
];

const UploadsHistory = () => (
    <React.Fragment>
        <Tunnel id="bluebar-left-content">
            <BackButtonTopbar link="/entities/">
                <div css={styles.title}>Uploads History</div>
            </BackButtonTopbar>
        </Tunnel>

        <Query
            query={GET_BULKUPLOAD_HISTORY}
            fetchPolicy="cache-and-network"
            variables={{
                count: DEFAULT_PAGESIZE,
                cursor: null,
            }}
        >
            {withApolloState(apolloProps => {
                return (
                    <ApolloPaginationTable
                        apolloProps={apolloProps}
                        columns={columns}
                    />
                );
            })}
        </Query>
    </React.Fragment>
);

export default UploadsHistory;
